import axios, { AxiosError, AxiosRequestConfig } from "axios"
import { FIELDS } from "lib"
import { PATH_MASS, PATH_RETENTION, PATH_UPLOAD } from "../../constants/paths"
import {
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials,
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
} from "interceptors"

const instance = axios.create({
  baseURL: process.env.REACT_APP_DOCUMENTS_API_SERVICE_DOMAIN,
})

instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

const formDataConfig: AxiosRequestConfig = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
}

export const uploadExcelFile = async (file: any) => {
  const formData = new FormData()
  formData.append(FIELDS.file.key, file)
  try {
    const result = await instance.post(
      PATH_RETENTION + PATH_MASS + PATH_UPLOAD,
      formData,
      formDataConfig
    )
    return result.status
  } catch (error: any) {
    const e: AxiosError = error
    return e.response?.status || 0
  }
}
